/**
 * Gemeinde entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from './BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';

export class Ort extends BaseModel {
    public id: number | null = null;
    public ortschaftsname: string | null = null;
    public plz: number | null = null;
    public zusatzziffer: number | null = null;
    public plz_typ: number | null = null;
    public bfsnr: number | null = null;
    public kantonskuerzel: string | null = null;
    public sprache: string | null = null;
    public plz_ort: string | null = null;
    public ident: string | null = null;


    mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'Ort';
    }

}

export class OrtCollection extends BaseCollection<Ort> {
    protected modelCls = Ort;

    public getModelClassName(): string {
        return 'Ort';
    }
}
